// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"8120":"cb79e8303c0909accae0","8623":"70438a0794986f415b3e"}[chunkId] + ".chunk.css";
};